
(() => {
  // Find the product <form> (Dawn/derivatives + fallback)
  const form =
    document.querySelector('product-form form') ||
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector('form[action^="/cart/add"]');

  if (!form) return;

  // Read the extras (checkboxes)
  function getExtras() {
    return Array.from(document.querySelectorAll('.better-together__checkbox-input:checked'))
      .map(el => {
        const item = {
          id: Number(el.value),
          quantity: Number(el.dataset.qty || 1),
          properties: { _bundle: 'Better Together' } // optional (marks the origin)
        };
        // If any extra is a subscription, you can add data-selling-plan="{{ plan_id }}"
        if (el.dataset.sellingPlan) item.selling_plan = Number(el.dataset.sellingPlan);
        return item;
      });
  }

  // Prevents recursion when we call requestSubmit()
  let passThrough = false;

  async function onSubmitCapture(e) {
    if (passThrough) return; // let Recharge/theme handle it

    const extras = getExtras();
    if (!extras.length) return; // no extras? normal flow

    // We have extras: add them first and then hand over to Recharge
    e.preventDefault();
    e.stopImmediatePropagation();

    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: extras })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        console.warn('Failed to add extras:', data);
      }
    } catch (err) {
      console.warn('Error adding extras:', err);
    } finally {
      // Now let Recharge continue with normal submit
      passThrough = true;
      form.requestSubmit(); // triggers submit again → Recharge intercepts and handles the main product
      // release the barrier on next tick to not catch this submit
      setTimeout(() => { passThrough = false; }, 0);

      document.querySelectorAll('.better-together__checkbox-input:checked').forEach(el => el.checked = false);
    }
  }

  // CAPTURE = true to run before Recharge
  form.addEventListener('submit', onSubmitCapture, true);
})();